module.exports = __webpack_public_path__ + "img/Homeplan logo (new modern April 2022 - NO .com).4a6108f5.svg";